import {
  createFrontendPlugin,
  FrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { convertLegacyRouteRef } from '@backstage/core-compat-api';
import { rootRouteRef } from './routes';

const deleteEntityPage = PageBlueprint.make({
  name: 'delete-entity',
  params: {
    path: '/ciandtspike-delete-entity',
    routeRef: convertLegacyRouteRef(rootRouteRef),
    loader: () =>
      import('./components/DeleteEntityComponent').then(m => (
        <m.DeleteEntityComponent />
      )),
  },
});

export const ciandtspikeDeleteEntityPlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'ciandtspike-delete-entity',
  extensions: [deleteEntityPage],
  routes: {
    root: convertLegacyRouteRef(rootRouteRef),
  },
});

// Re-export para uso no EntityPage enquanto ele estiver no compat bridge (S2.1)
export { DeleteEntityComponent as CiandtspikeDeleteEntityPage } from './components/DeleteEntityComponent';

export default ciandtspikeDeleteEntityPlugin;
